export const projects = [
  {
    id: 1,
    name: "GyanUdaan",
    category: "FLAGSHIP_EDTECH",
    stats: "40K+ Downloads",
    desc: "End-to-end EdTech ecosystem with real-time sync across mobile, web and desktop.",
    platforms: ["Google Play", "App Store", "Desktop"],
    image: "/logo.png",
    imageClassName: "h-12 w-32 md:h-14 md:w-40",
    link: "https://gyanudaan.com/links",
    caseStudy: "/gyanudaan",
    caseStudyLabel: "Open Case Study",
    tech: ["Expo", "Tauri", "PowerSync", "Supabase", "Firebase", "n8n", "Sentry", "Bun", "React Admin"],
    features: [
      "Real-time Sync (PowerSync)",
      "Mobile + Desktop (Tauri)",
      "Automated AI Pipelines (n8n)",
      "Error Monitoring (Sentry)",
    ],
    color: "from-blue-50 to-white",
  },
  {
    id: 2,
    name: "PikaDevs",
    category: "AGENCY_FOUNDER",
    stats: "Service Scale",
    desc: "Web development agency delivering fast, SEO-optimized websites for international clients.",
    features: [
      "Custom Admin Dashboards",
      "Secure Authentication",
      "SEO Optimization",
      "Client Acquisition",
    ],
    tech: ["React", "Astro", "Tailwind", "Supabase"],
    image: "/pikadevs.png",
    color: "from-purple-50 to-white",
  },
  {
    id: 3,
    name: "Minute News",
    category: "AI_NEWS_APP",
    stats: "Prototype",
    desc: "TikTok-style news app with AI summarization and swipe-based UI.",
    features: [
      "AI News Summarization",
      "Redis Caching Layer",
      "Swipe-based UI",
      "Automated Scraping",
    ],
    tech: ["Expo", "Node.js", "Scrapy", "Redis", "Gemini API"],
    color: "from-pink-50 to-white",
  },
  {
    id: 4,
    name: "CBFEWS App",
    category: "FREELANCE_ICIMOD",
    stats: "Live on Play Store",
    desc: "Community-Based Flood Early Warning System mobile app built freelance for ICIMOD to keep communities ahead of rising rivers.",
    features: [
      "Real-time Flood Alerts",
      "Community-based Warnings",
      "Simple & Reliable Alerts",
    ],
    platforms: ["Google Play"],
    tech: ["Android", "Java"],
    link: "https://play.google.com/store/apps/details?id=com.icimod.cbewsapp&hl=en",
    color: "from-teal-50 to-white",
  },
  {
    id: 5,
    name: "LML Inventory & Billing",
    category: "FREELANCE_ICIMOD",
    stats: "Deployed",
    desc: "Inventory management and billing system built freelance for ICIMOD to streamline stock and sales.",
    features: [
      "Inventory Management",
      "Billing & Invoicing",
      "Streamlined Sales Workflow",
    ],
    platforms: ["Web"],
    tech: ["React", "Node.js"],
    color: "from-amber-50 to-white",
  },
  {
    id: 6,
    name: "Shahu Automobiles",
    category: "FREELANCE_SUZUKI",
    stats: "Live",
    desc: "Web platform built freelance for Shahu Automobiles (Suzuki) to showcase models and drive customer enquiries.",
    features: [
      "Vehicle Showcase",
      "Model Catalog",
      "Customer Enquiries",
    ],
    platforms: ["Web"],
    tech: ["React", "Node.js"],
    link: "https://www.shahuautomobiles.com.np/",
    color: "from-emerald-50 to-white",
  },
];